/* eslint-disable no-unused-vars */
import { Dialog, Grid, Typography } from "@mui/material";

import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { withStyles } from "@mui/styles";
import MuiDialogContent from "@mui/material/DialogContent";

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const DialogContentBoderLess = withStyles((theme) => ({
  root: {
    padding: theme.spacing(0),
    "&:first-child": {
      padding: 0,
    },
  },
}))(MuiDialogContent);

export default function LastSaleSummary(props) {
  const { t } = useTranslation();
  const translate = t;

  const [price, setPrice] = useState("");
  const [priceError, setPriceError] = useState("");
  const [formnatType, setFormatType] = useState(null);

  useEffect(() => {
    console.log(props.lastBill);
    if (props.lastBill.length == 1) {
      setFormatType("single");
    } else {
      setFormatType("multi");
    }
  }, [props.lastBill]);

  function parentEvent(event, value) {
    if ("openWindow" === event) {
      //setOpenWindow(value);
      setPrice("");
    }
  }

  function onSave() {}

  const content = (
    <div>
      {formnatType === "single" && (
        <Grid
          container
          style={{
            paddingTop: 10,
            paddingLeft: 20,
            paddingRight: 20,
            paddingBottom: 10,
            background: "#4a148c",
            color: "#fff",
          }}
        >
          <Grid item xs={6}>
            <Typography variant="h4" gutterBottom component="div">
              Total Amount
            </Typography>
          </Grid>
          <Grid item xs={6} style={{ textAlign: "right" }}>
            <Typography variant="h4" gutterBottom component="div">
              {props.lastBill.total} {" " + props.context.store.currency}
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="h4" gutterBottom component="div">
              Tendered
            </Typography>
          </Grid>
          <Grid item xs={6} style={{ textAlign: "right" }}>
            <Typography variant="h4" gutterBottom component="div">
              {props.lastBill.paycodes[0].tenderedInActualCurr}{" "}
              {" " +
                (props.lastBill.paycodes[0].payCode == "CASH"
                  ? props.context.store.currency
                  : props.lastBill.paycodes[0].payCode)}
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="h4" gutterBottom component="div">
              Balance
            </Typography>
          </Grid>
          <Grid item xs={6} style={{ textAlign: "right" }}>
            <Typography variant="h4" gutterBottom component="div">
              {props.lastBill.paycodes[0].balanceWithCurrency}
            </Typography>
          </Grid>
        </Grid>
      )}
      {formnatType === "multi" && (
        <Grid
          container
          style={{
            paddingTop: 10,
            paddingLeft: 20,
            paddingRight: 20,
            paddingBottom: 10,
            background: "#4a148c",
            color: "#fff",
          }}
        >
          <Grid item xs={6}>
            <Typography variant="h4" gutterBottom component="div">
              Total Amount
            </Typography>
          </Grid>
          <Grid item xs={6} style={{ textAlign: "right" }}>
            <Typography variant="h4" gutterBottom component="div">
              {props.lastBill.total} {" " + props.context.store.currency}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <table width="100%" style={{ fontSize: "1.5rem" }}>
              <tbody>
                <th style={{ textAlign: "left" }}>Pay Code</th>
                <th style={{ textAlign: "right" }}>Given</th>
                <th style={{ textAlign: "right" }}>Amount</th>
                <th style={{ textAlign: "right" }}>Balance</th>
                {props.lastBill.paycodes.map((item, index) => (
                  <tr>
                    <td style={{ textAlign: "left" }}>{item.payCode}</td>
                    <td style={{ textAlign: "right" }}>
                      {item.tenderedInActualCurr}
                    </td>
                    <td style={{ textAlign: "right" }}>{item.amount}</td>
                    <td style={{ textAlign: "right" }}>
                      {item.balanceWithCurrency}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </Grid>
        </Grid>
      )}
    </div>
  );

  function onKeyPress() {
    console.log("Key Pressed");
    props.closeLastSaleSummary();
  }

  return (
    <div>
      <Dialog
        onClose={(event, reason) => {
          props.closeLastSaleSummary();
        }}
        onBackdropClick={(event) => {
          props.closeLastSaleSummary();
        }}
        aria-labelledby="customized-dialog-title"
        open={true}
        onKeyDown={onKeyPress}
        maxWidth={"sm"}
        fullWidth={false}
        disableBackdropClick
      >
        <DialogContentBoderLess dividers>{content}</DialogContentBoderLess>
      </Dialog>
    </div>
  );
}
